import React from 'react';
import {StyleSheet} from 'react-native';
import {faArrowLeftLong} from '@fortawesome/free-solid-svg-icons/faArrowLeftLong';
import {FontAwesomeIcon} from '@fortawesome/react-native-fontawesome';

import theme from '../../../style/theme';
import Text from '../../themed/Text';
import PressableWithOpacityFeedback from '../../ui-controls/PressableWithOpacityFeedback';

type BackButtonProps = {
  onPress: () => void;
};

function BackButton({onPress}: BackButtonProps) {
  return (
    <PressableWithOpacityFeedback onPress={onPress} style={styles.container}>
      <FontAwesomeIcon
        icon={faArrowLeftLong}
        size={16}
        color={styles.text.color}
      />
      <Text style={styles.text}>Back</Text>
    </PressableWithOpacityFeedback>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 5,
  },
  text: {
    color: theme.colour.background.button.primary,
    paddingLeft: 8,
    paddingTop: 0,
  },
});

export default BackButton;
